// extracted by mini-css-extract-plugin
module.exports = {"OrderFooter":"OrderCreatePage_OrderFooter__ie2tC","ButtonRow":"OrderCreatePage_ButtonRow__D0S70","Modal":"OrderCreatePage_Modal__1LOOr"};